import { render, staticRenderFns } from "./user-general-view.vue?vue&type=template&id=5a7c3215&scoped=true"
import script from "./user-general-view.vue?vue&type=script&lang=ts"
export * from "./user-general-view.vue?vue&type=script&lang=ts"
import style0 from "./user-general-view.vue?vue&type=style&index=0&id=5a7c3215&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7c3215",
  null
  
)

export default component.exports